var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":""}},[_c('TheSnackbar'),_vm._v(" "),_c('v-main',[_c('v-container',{staticClass:"pa-0"},[_c('nuxt')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }